/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { CategoriesSearchAtom } from "../../../atoms/CategoriesAtom";
import { SelectedCategoriesAtom } from "../../../atoms/SelectedCategoriesAtom";
import CreateOrUpdateCategory from "../../Modal/container/Tags/CreateOrUpdateCategory";
import { useModal } from "../../Modal/Modal";
import SearchInput from "../../SearchInput";
import StyledButton from "../../StyledButton";
import CategoriesBulkActions from "./CategoriesBulkActions";

const Container = styled.div`
  width: 100%;
  height: fit-content;
  border-bottom: 1px solid #cccccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  padding-left: 25px;
  background-color: #ffffff;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const marginRight15 = css`
  margin-right: 15px;
`;

export default function CategoriesHeader(): JSX.Element {
  const modal = useModal();
  const [categoriesSearch, setCategoriesSearch] =
    useRecoilState(CategoriesSearchAtom);
  const selectedCategories = useRecoilValue(SelectedCategoriesAtom);

  return (
    <Container>
      <div style={{ width: 320 }}>
        <SearchInput
          placeholder="Search for category name"
          value={categoriesSearch}
          handleChange={(evt) => setCategoriesSearch(evt)}
        />
      </div>
      <Flex>
        {selectedCategories.length > 1 && (
          <div css={marginRight15}>
            <CategoriesBulkActions />
          </div>
        )}
        <StyledButton
          onClick={() =>
            modal.pushModal(
              <CreateOrUpdateCategory onCancel={() => modal.popModal()} />,
              "Create category"
            )
          }
        >
          Create a Category
        </StyledButton>
      </Flex>
    </Container>
  );
}
